import { ReactElement } from 'react';

const DownChevronIcon = (props: TClassNameProps): ReactElement => (
	<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.47205 5.13807C5.21171 5.39842 4.7896 5.39842 4.52925 5.13807L0.529246 1.13807C0.268897 0.877722 0.268897 0.455612 0.529246 0.195262C0.789596 -0.0650875 1.21171 -0.0650875 1.47206 0.195262L5.00065 3.72386L8.52925 0.195263C8.78959 -0.0650868 9.21171 -0.0650868 9.47205 0.195263C9.7324 0.455613 9.7324 0.877723 9.47205 1.13807L5.47205 5.13807Z"
			fill="currentColor"
		/>
	</svg>
);

export default DownChevronIcon;
